import _JSXStyle from "styled-jsx/style";
import { spacers } from '@dhis2/ui-constants';
import PropTypes from 'prop-types';
import React from 'react';
export const ModalActions = _ref => {
  let {
    children,
    dataTest = 'dhis2-uicore-modalactions'
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    "data-test": dataTest,
    className: _JSXStyle.dynamic([["2674552674", [spacers.dp16]]])
  }, children, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "2674552674",
    dynamic: [spacers.dp16]
  }, [`div.__jsx-style-dynamic-selector{-webkit-order:3;-ms-flex-order:3;order:3;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end;-webkit-align-self:flex-end;-ms-flex-item-align:end;align-self:flex-end;margin:${spacers.dp16} 0 0;}`]));
};
ModalActions.propTypes = {
  children: PropTypes.node,
  dataTest: PropTypes.string
};